var _path, _g, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g6, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg41(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 136,
    viewBox: "0 0 200 136",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 0,
    width: 45,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.865 0.234375H199.729V37.5677H155.865V0.234375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.771 0.901062C198.771 0.901062 187.365 10.2761 185.333 32.974L173.88 28.0781L170.75 36.849L168.328 26.1146C168.328 26.1146 158.474 21.9323 156.917 19.0677C156.917 19.0677 180.708 13.0209 198.771 0.901062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 0,
    width: 45,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.865 0H199.729V38.901H155.865V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.771 0.901514C198.771 0.901514 187.365 10.2765 185.333 32.9744L173.88 28.0785L170.75 36.8494L168.328 26.115C168.328 26.115 158.474 21.9327 156.917 19.0682C156.917 19.0682 180.708 13.0213 198.771 0.901514Z",
    stroke: "#231F20",
    strokeWidth: 1.61781,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.057 29.865L170.75 36.8494L178.057 29.865Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.057 29.865L170.75 36.8494",
    stroke: "#231F20",
    strokeWidth: 1.61781,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 0,
    width: 33,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.865 0.234375H199.729V28.2344H167.865V0.234375Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.88 28.0781C185.875 10.5625 198.771 0.901062 198.771 0.901062C198.771 0.901062 174.521 17.7292 168.328 26.1146",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 0,
    width: 34,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.531 0H199.729V29.5677H166.531V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.88 28.0785C185.875 10.5629 198.771 0.901452 198.771 0.901452C198.771 0.901452 174.521 17.7296 168.328 26.115",
    stroke: "#231F20",
    strokeWidth: 1.61781,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 130,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 130.901H5.19792V135.818H0V130.901Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.604156 134.87C1.63541 133.891 2.6927 132.906 3.78124 131.927L4.46874 133.172L2.97916 134.073L0.874989 135.359L0.604156 134.87Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92709 130.021C6.98439 129.089 8.07293 128.156 9.1823 127.224L9.69793 128.161C8.58855 129.094 7.50001 130.026 6.44272 130.958L5.92709 130.021Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3854 125.406C12.4688 124.51 13.5781 123.62 14.7031 122.729L15.2136 123.656C14.0886 124.552 12.9792 125.443 11.8906 126.333L11.3854 125.406Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 120.979C18.0469 120.12 19.1667 119.26 20.3125 118.401L20.8177 119.323C19.6823 120.188 18.5573 121.047 17.4479 121.906L16.9375 120.979Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5729 116.708C23.6979 115.875 24.8386 115.042 25.9948 114.208L26.5052 115.135C25.349 115.969 24.2084 116.802 23.0834 117.635L22.5729 116.708Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2917 112.563C29.4323 111.75 30.5781 110.943 31.7448 110.135L32.2552 111.057C31.0886 111.87 29.9375 112.677 28.8021 113.49L28.2917 112.563Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0573 108.531C35.2136 107.74 36.375 106.943 37.5469 106.156L38.0573 107.083C36.8854 107.875 35.724 108.667 34.5729 109.458L34.0573 108.531Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8802 104.589C41.0469 103.818 42.2188 103.047 43.4011 102.276L43.9115 103.203C42.7292 103.974 41.5625 104.745 40.3906 105.521L39.8802 104.589Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7552 100.74C46.9323 99.974 48.1146 99.2188 49.2969 98.4636L49.8125 99.3959C48.6198 100.151 47.4375 100.911 46.2656 101.672L45.7552 100.74Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 96.9636C52.849 96.2136 54.0365 95.4688 55.2344 94.7292L55.7448 95.6563C54.5521 96.4011 53.3594 97.1459 52.1771 97.8906L51.6667 96.9636Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6146 93.25C58.8021 92.5157 60 91.7813 61.1979 91.0521L61.7136 91.9896C60.5156 92.7136 59.3177 93.448 58.125 94.1823L57.6146 93.25Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.599 89.599C64.7969 88.875 66 88.151 67.2031 87.4375L67.7136 88.3698C66.5104 89.0885 65.3125 89.8073 64.1146 90.5312L63.599 89.599Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6094 86.0052C70.8177 85.2917 72.026 84.5833 73.2292 83.875L73.7448 84.8073C72.5365 85.5156 71.3281 86.224 70.125 86.9427L69.6094 86.0052Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6511 82.4636C76.8646 81.7605 78.0781 81.0573 79.2917 80.3646L79.8021 81.2969C78.5938 81.9896 77.3802 82.6927 76.1667 83.4011L75.6511 82.4636Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7188 78.9688C82.9479 78.2709 84.1615 77.5834 85.375 76.8959L85.8906 77.8282C84.6771 78.5157 83.4583 79.2032 82.2344 79.9063L81.7188 78.9688Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4844 73.474L91.9948 74.4063C90.776 75.0834 89.5521 75.7657 88.3281 76.4584L87.8125 75.5209C89.0417 74.8334 90.2656 74.1511 91.4844 73.474Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9323 72.1198C95.1615 71.4375 96.3906 70.7605 97.6094 70.099L98.125 71.0261C96.9011 71.6927 95.6823 72.3698 94.4427 73.0521L93.9323 72.1198Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.073 68.75C101.313 68.0729 102.542 67.4062 103.76 66.75L104.276 67.6823C103.057 68.3385 101.823 69.0052 100.583 69.6823L100.073 68.75Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.229 65.4219C107.474 64.7552 108.708 64.0938 109.932 63.4427L110.443 64.375C109.229 65.0261 107.99 65.6823 106.74 66.3542L106.229 65.4219Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.406 62.1354C113.661 61.4688 114.901 60.8177 116.125 60.1719L116.635 61.1042C115.411 61.7448 114.172 62.401 112.917 63.0625L112.406 62.1354Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.609 58.875C119.87 58.2135 121.115 57.5677 122.339 56.9375L122.844 57.8594C121.625 58.4948 120.38 59.1458 119.12 59.8021L118.609 58.875Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.823 55.6563C126.094 55 127.344 54.3594 128.563 53.7396L129.073 54.6615C127.854 55.2813 126.604 55.9271 125.333 56.5782L124.823 55.6563Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.057 52.4636C132.339 51.8177 133.589 51.1823 134.812 50.5677L135.318 51.4896C134.099 52.1042 132.849 52.7344 131.568 53.3855L131.057 52.4636Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.318 49.3073C138.615 48.6563 139.87 48.0313 141.078 47.4323L141.583 48.3438C140.375 48.9479 139.12 49.5729 137.823 50.2292L137.318 49.3073Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M147.359 44.3281L147.865 45.2448C146.677 45.8281 145.417 46.4479 144.089 47.099L143.589 46.1875C144.906 45.5365 146.167 44.9115 147.359 44.3281Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.667 41.2656L154.068 42L152.297 43.0833L150.479 44.1875L149.88 43.099C151.255 42.4323 152.526 41.8177 153.667 41.2656Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M160.953 37.8073L156.464 40.5417L156.198 40.0521C159.255 38.5886 160.953 37.8073 160.953 37.8073Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2427_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 130,
    width: 6,
    height: 6
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 130.901H5.19792V135.818H0V130.901Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2427_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0833435 133.917C1.10939 132.943 2.17709 131.969 3.26564 130.99L4.30209 132.87C3.85418 133.266 3.41147 133.672 2.97918 134.073C2.35418 134.656 1.73439 135.24 1.13022 135.818L0.0833435 133.917Z",
    fill: "#231F20"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41669 129.094C6.47398 128.161 7.56773 127.234 8.6771 126.307L9.69794 128.161C8.58856 129.094 7.50002 130.026 6.44273 130.958L5.41669 129.094Z",
    fill: "#231F20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8802 124.49C11.9688 123.604 13.0781 122.714 14.2083 121.823L15.2136 123.656C14.0886 124.552 12.9792 125.443 11.8906 126.333L10.8802 124.49Z",
    fill: "#231F20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4427 120.078C17.5521 119.219 18.6771 118.359 19.8177 117.505L20.8177 119.323C19.6823 120.188 18.5573 121.047 17.4479 121.906L16.4427 120.078Z",
    fill: "#231F20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 115.818C23.2083 114.984 24.349 114.151 25.5052 113.323L26.5052 115.135C25.349 115.969 24.2083 116.802 23.0833 117.635L22.0833 115.818Z",
    fill: "#231F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8021 111.677C28.9427 110.865 30.099 110.052 31.2604 109.25L32.2552 111.057C31.0886 111.87 29.9375 112.677 28.8021 113.49L27.8021 111.677Z",
    fill: "#231F20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5729 107.651C34.7292 106.854 35.8906 106.063 37.0625 105.276L38.0573 107.083C36.8854 107.875 35.724 108.667 34.5729 109.458L33.5729 107.651Z",
    fill: "#231F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3958 103.714C40.5625 102.938 41.7344 102.161 42.9167 101.391L43.9115 103.203C42.7292 103.974 41.5625 104.745 40.3906 105.521L39.3958 103.714Z",
    fill: "#231F20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2708 99.8594C46.4479 99.099 47.6302 98.3334 48.8125 97.5834L49.8125 99.3959C48.6198 100.151 47.4375 100.911 46.2656 101.672L45.2708 99.8594Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1771 96.0781C52.3698 95.3281 53.5521 94.5885 54.7448 93.8438L55.7448 95.6562C54.5521 96.401 53.3594 97.1458 52.1771 97.8906L51.1771 96.0781Z",
    fill: "#231F20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.125 92.3646C58.3177 91.6302 59.5156 90.8959 60.7135 90.1667L61.7135 91.9896C60.5156 92.7136 59.3177 93.4479 58.125 94.1823L57.125 92.3646Z",
    fill: "#231F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1094 88.7135C64.3177 87.9844 65.5156 87.2656 66.7135 86.5469L67.7135 88.3698C66.5104 89.0885 65.3125 89.8073 64.1146 90.5312L63.1094 88.7135Z",
    fill: "#231F20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1198 85.1198C70.3334 84.401 71.5417 83.6875 72.7396 82.9844L73.7448 84.8073C72.5365 85.5156 71.3281 86.224 70.125 86.9427L69.1198 85.1198Z",
    fill: "#231F20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1615 81.5729C76.375 80.8646 77.5886 80.1615 78.7969 79.4688L79.8021 81.2969C78.5938 81.9896 77.3802 82.6927 76.1667 83.401L75.1615 81.5729Z",
    fill: "#231F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2292 78.0781C82.4584 77.375 83.6771 76.6823 84.8802 75.9948L85.8906 77.8281C84.6771 78.5156 83.4584 79.2031 82.2344 79.9063L81.2292 78.0781Z",
    fill: "#231F20"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9844 72.5729L91.9948 74.4063C90.7761 75.0834 89.5521 75.7656 88.3281 76.4584L87.3177 74.625C88.5521 73.9271 89.7761 73.25 90.9844 72.5729Z",
    fill: "#231F20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2865 69.6459C96.5625 69.4948 96.8386 69.3438 97.1146 69.1979L98.125 71.0261C96.9011 71.6927 95.6823 72.3698 94.4427 73.0521L93.4323 71.2188C94.3229 70.724 95.2084 70.2396 96.0834 69.7604L96.2865 69.6459Z",
    fill: "#231F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5729 67.849C100.818 67.1771 102.042 66.5105 103.271 65.849L104.276 67.6823C103.057 68.3386 101.823 69.0052 100.583 69.6823L99.5729 67.849Z",
    fill: "#231F20"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 64.5209C106.979 63.8542 108.214 63.1927 109.438 62.5417L110.443 64.375C109.229 65.0261 107.99 65.6823 106.74 66.3542L105.734 64.5209Z",
    fill: "#231F20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.911 61.2344C113.167 60.5677 114.406 59.9167 115.625 59.2761L116.635 61.1042C115.411 61.7448 114.172 62.4011 112.917 63.0625L111.911 61.2344Z",
    fill: "#231F20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M118.115 57.974C119.375 57.3177 120.62 56.6667 121.839 56.0365L122.844 57.8594C121.625 58.4948 120.38 59.1459 119.12 59.8021L118.115 57.974Z",
    fill: "#231F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.333 54.7552C125.599 54.099 126.849 53.4584 128.068 52.8334L129.073 54.6615C127.854 55.2813 126.604 55.9271 125.333 56.5782L124.333 54.7552Z",
    fill: "#231F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M130.568 51.5677C131.849 50.9115 133.094 50.2865 134.318 49.6719L135.318 51.4896C134.099 52.1042 132.849 52.7344 131.568 53.3854L130.568 51.5677Z",
    fill: "#231F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136.823 48.4063C138.12 47.7552 139.375 47.1355 140.583 46.5365L141.583 48.3438C140.375 48.948 139.12 49.573 137.823 50.2292L136.823 48.4063Z",
    fill: "#231F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.865 43.4271L147.865 45.2448C146.677 45.8282 145.417 46.448 144.089 47.099L143.094 45.2865C144.411 44.6355 145.677 44.0105 146.865 43.4271Z",
    fill: "#231F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M153.167 40.3646L154.167 42.1771C153.573 42.4636 152.948 42.7657 152.297 43.0834C151.688 43.3802 151.047 43.6875 150.38 44.0157L149.38 42.198C150.76 41.5313 152.026 40.9167 153.167 40.3646Z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M160.557 36.849L160.953 37.8073L161.349 38.7552C161.219 38.8177 159.573 39.5834 156.698 40.9636L155.698 39.1511C158.76 37.6875 160.49 36.8855 160.557 36.849Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg41);
export default __webpack_public_path__ + "static/media/svg41.3cae6cc9503b29e9940a00b2b8577295.svg";
export { ForwardRef as ReactComponent };